module.exports = __webpack_public_path__ + "static/media/calcium.f485e79d.svg";